import ReactDOM from 'react-dom';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import store from './store';
import { saveState } from './store/persistState';

// style + assets
import 'assets/scss/style.scss';
import config from 'config';

// Load persisted data at start up
store.subscribe(() => {
    saveState({ state: store.getState() });
});

const queryClient = new QueryClient();

// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
